import React from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../generic/CustomBtn';
import './Sorting.scss';

const Sorting = ({ activeSort, setActiveSort }) => {
  const translate = useIntl();

  const sortingItems = [
    { label: translate.formatMessage({ id: 'existing.filter.status' }), key: 'status.keyword', class: '' },
    { label: translate.formatMessage({ id: 'existing.filter.name' }), key: 'name.keyword', class: '' },
    {}, // empty element for grid layout
    { label: translate.formatMessage({ id: 'existing.filter.carbon' }), key: '', class: 'sorting__carbon' },
    { label: translate.formatMessage({ id: 'existing.filter.stage' }), key: 'currentStage', class: '' },
    { label: translate.formatMessage({ id: 'existing.filter.location' }), key: '', class: '' },
    { label: translate.formatMessage({ id: 'existing.filter.area' }), key: 'parsedSquare', class: '' },
    { label: translate.formatMessage({ id: 'existing.filter.duration' }), key: 'deadline', class: '' },
    {}, // empty element for grid layout
  ];

  const sortNftTokens = (key) => {
    if (!key) return;

    if (activeSort.key === key) {
      setActiveSort({ ...activeSort, value: activeSort.value === 'asc' ? 'desc' : 'asc' });
      return;
    }
    setActiveSort({ key, value: 'asc' });
  };

  const getAscendSortClass = (key) => (activeSort.key === key && activeSort.value === 'asc' ? 'ascend' : '');

  return (
    <div className="sorting">
      {sortingItems.map((item, index) => (
        item
          ? (
            <CustomBtn
              label={item.label}
              iconClass={item.key ? 'icon-filter-arrow-down' : ''}
              handleClick={() => sortNftTokens(item.key)}
              customClass={`sorting__button ${item.class} ${getAscendSortClass(item.key)}`}
              disabled={!item.key}
              // eslint-disable-next-line react/no-array-index-key
              key={`sorting-${index}`}
            />
          )
          // eslint-disable-next-line react/no-array-index-key
          : <div key={`sorting-${index}`} /> // empty grid cell
      ))}
    </div>
  );
};

export default Sorting;
